module.exports = __webpack_public_path__ + "img/banner-home.10d4f086.jpg";